export default "__VITE_ASSET__jDMd4lAg__"